import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)



let initialRole = 'public'

/*
const userInfo = JSON.parse(localStorage.getItem('userInfoAuth'))
console.log(userInfo)
if (userInfo && userInfo.ROLE) initialRole = userInfo.ROLE == "Company" ? "public" : userInfo.ROLE == "Owner" ? "editor" : "admin"
console.log(initialRole)*/
export default new AclCreate({
	initial: initialRole,
	notfound: '/pages/not-authorized',
	router,
	acceptLocalRules: true,
	//public -> home,login,stock,depo (owner, admin, company)
	//editor -> role,user (owner)
	//admin -> company (owner, admin)
	globalRules: {
		admin: new AclRule('public').generate(), //--> role company can reach only public ( home,login,stock,depo)
		editor: new AclRule('admin').or('public').generate(), //--> role admin can reach only two ( company, home,login,stock,depo)
		public: new AclRule('public').or('admin').or('editor').generate(), //--> role owner can reach all (role,user, company, home,login,stock,depo)
	}
})
